import styled from 'styled-components/macro'
import { media, rem } from '../../utils/styles'

const padding = rem(12)

const MainWrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding-left: ${padding};
  padding-right: ${padding};
  max-width: ${rem(659)};
  width: 100%;

  ${media('tablet')`
    max-width: ${rem(740)};
  `}

  ${media('desktop')`
    max-width: ${rem(1004)};
  `}

  ${media('large')`
    max-width: ${rem(1168)};
  `}

  ${media('xLarge')`
    max-width: ${rem(1432)};
  `}
`

export default MainWrapper
